import Box from '@mui/material/Box'
import React from 'react'

// label prop will render the text label for its parent (AdxTabsBadge)
const AdxTabsPanel = ({ children, sx, label, notification, ...rest }) => {
  return (
    <Box
      aria-label={`label: ${label ? label : 'label'}, notication: ${
        notification ? notification : 0
      }`}
      sx={{ ...sx }}
      {...rest}
    >
      {children}
    </Box>
  )
}
export default AdxTabsPanel
